(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lotto/components/result/views/andra-chansen-winner.js') >= 0) return;  svs.modules.push('/modules/lotto/components/result/views/andra-chansen-winner.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.lotto=_svs.lotto||{};
_svs.lotto.components=_svs.lotto.components||{};
_svs.lotto.components.result=_svs.lotto.components.result||{};
_svs.lotto.components.result.templates=_svs.lotto.components.result.templates||{};
svs.lotto.components.result.templates.andra_chansen_winner = Handlebars.template({"0":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "  <div class=\"andra-chansen-cities-wrapper u-flex u-flex-column padding-2\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"winningLocations") : depth0)) != null ? lookupProperty(stack1,"winners") : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":4,"column":4},"end":{"line":6,"column":11}}})) != null ? stack1 : "")
    + "    <div class=\"ac-cities\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(alias1,((stack1 = (depth0 != null ? lookupProperty(depth0,"winningLocations") : depth0)) != null ? lookupProperty(stack1,"cities") : stack1),{"name":"each","hash":{},"fn":container.program(2, data, 1, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":8,"column":6},"end":{"line":10,"column":15}}})) != null ? stack1 : "")
    + "    </div>\n  </div>\n";
},"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "      <p class=\"h2\">Veckans "
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"winningLocations") : depth0)) != null ? lookupProperty(stack1,"winners") : stack1), depth0))
    + " miljonvinster gick till</p>\n";
},"2":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <p class=\"city-name f-600 "
    + alias2(alias1(((stack1 = blockParams[0][0]) != null ? lookupProperty(stack1,"className") : stack1), depth0))
    + "\">"
    + alias2(alias1(((stack1 = blockParams[0][0]) != null ? lookupProperty(stack1,"name") : stack1), depth0))
    + "</p>\n";
},"3":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <p class=\"h4\">Andra Chansen</p>\n    <div class=\"andra-chansen-winner-text\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),((stack1 = (depth0 != null ? lookupProperty(depth0,"winningLocations") : depth0)) != null ? lookupProperty(stack1,"cities") : stack1),{"name":"each","hash":{},"fn":container.program(4, data, 1, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":16,"column":6},"end":{"line":22,"column":15}}})) != null ? stack1 : "")
    + "    </div>\n";
},"4":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <p class=\"h3\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),blockParams[0][0],{"name":"each","hash":{},"fn":container.program(5, data, 1, blockParams),"inverse":container.noop,"data":data,"blockParams":blockParams,"loc":{"start":{"line":18,"column":10},"end":{"line":20,"column":19}}})) != null ? stack1 : "")
    + "        </p>\n";
},"5":function(container,depth0,helpers,partials,data,blockParams) {
    return "            "
    + container.escapeExpression(container.lambda(blockParams[0][0], depth0))
    + " <br/>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"andra-chansen-winner-container f-content\">\n"
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"isMultipleLocations") : depth0),{"name":"if","hash":{},"fn":container.program(0, data, 0, blockParams),"inverse":container.program(3, data, 0, blockParams),"data":data,"blockParams":blockParams,"loc":{"start":{"line":2,"column":2},"end":{"line":24,"column":9}}})) != null ? stack1 : "")
    + "</div>\n";
},"useData":true,"useBlockParams":true});
Handlebars.partials['svs-lotto-components-result-andra_chansen_winner'] = svs.lotto.components.result.templates.andra_chansen_winner;
})(svs, Handlebars);


 })(window);